// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.99992 2V5L17.9999 5V2H19.9999V5H21.9999V7H19.9999V15H21.9999V17H19.9999V21H17.9999V17H15.9999V15H17.9999V7H7.99992V11H5.99992V7H1.99992V5H5.99992V2H7.99992ZM14.5807 10.4185L10.2051 23.5453L7.19684 17.8023L1.45386 14.7941L14.5807 10.4185Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-map-navigation-filled')
export default class MapNavigationFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-navigation-filled',
    }
  }
}
